import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
// import { processErrorMessage } from "../../../Helper/processErrorMessage";
import {
  API_GET_INVESTMENT_METRICS,
  API_GET_OPPORTUNITIES,
} from "../../../config/api";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const getMetrics = createAsyncThunk(
  "investment/metrics",
  async (currency, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_GET_INVESTMENT_METRICS + currency,
      });

      return response.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);

      // If you have a function to process the error message, use it here
      // const message = processErrorMessage(error);
      // toast.error(message);
      // Use rejectWithValue to return a rejected action with a specific payload
      return rejectWithValue(error.message || "Error fetching opportunities");
    }
  }
);
